import * as React from 'react';
import { Button, Dialog, DialogTitle } from '@material-ui/core';
import classnames from 'classnames';
import SignaturePad from 'signature_pad';

import { SignEstimateContainer } from '../sign-estimate';
import styles from './signature-image.less';

interface Props {
    container: SignEstimateContainer;
    isTablet?: boolean;
    isSubmitting: boolean;
}

export class SignatureImage extends React.Component<Props> {
    private signatureImage = '';
    private canvas: HTMLCanvasElement | null = null;
    private signaturePad: SignaturePad | undefined;

    private bindSignatureCanvas = (el: HTMLCanvasElement | null) => {
        if (el) {
            this.canvas = el;
            this.signaturePad = new SignaturePad(this.canvas);
            this.resizeSignatureCanvas();
            window.addEventListener('resize', this.resizeSignatureCanvas);
        } else {
            window.removeEventListener('resize', this.resizeSignatureCanvas);
            if (this.signaturePad) {
                this.signaturePad.off();
            }
        }
    };

    /**
     * clear canvas and change ratio when user using landscape mode
     */
    private resizeSignatureCanvas = () => {
        if (!this.canvas || !this.signaturePad) return;

        const canvasContent = this.canvas.getContext('2d');
        if (!canvasContent) return;

        const ratio = Math.max(window.devicePixelRatio || 1, 1);

        this.canvas.width = this.canvas.offsetWidth * ratio;
        this.canvas.height = this.canvas.offsetHeight * ratio;
        canvasContent.scale(ratio, ratio);

        this.signaturePad.clear();
    };

    private clearCanvas = () => {
        if (!this.signaturePad) return;
        this.signaturePad.clear();
        this.signatureImage = '';
    };

    private handleSubmit = () => {
        if (!this.signaturePad) return;
        if (this.signaturePad.isEmpty()) {
            alert('Please provide your signature.');
            return;
        }

        const dataURL = this.signaturePad.toDataURL();
        this.signatureImage = dataURL;
        this.props.container.handleSubmit(undefined, this.signatureImage);
    };

    render() {
        const { isSubmitting } = this.props;

        return (
            <Dialog
                open
                onClose={this.props.container.handleClose}
                maxWidth="md"
                className={this.props.isTablet ? styles.dialog : undefined}
                fullWidth
                fullScreen={!this.props.isTablet}
                disableEscapeKeyDown
                aria-labelledby="sign-estimate-dialog-title"
            >
                <DialogTitle
                    id="sign-estimate-dialog-title"
                    disableTypography
                    className={styles.title}
                >
                    Sign to accept estimate
                </DialogTitle>

                <div className={classnames('page', styles.page)}>
                    <div className={styles.signaturePadWrapper}>
                        <div className={styles.signaturePad}>
                            <div className={styles.indicator}></div>
                            <canvas ref={this.bindSignatureCanvas}></canvas>
                        </div>
                        <p className={styles.text}>
                            By entering your name above and clicking on the “Agree and Submit”
                            button you agree that you have reviewed and approved this document. You
                            further agree that entering your name will have the same force and
                            effect as your written signature.
                        </p>
                    </div>
                    <div className="non-sticky-button-wrapper no-margins">
                        <Button
                            className={classnames('next-step-button', styles.buttons)}
                            variant="contained"
                            color="primary"
                            onClick={this.clearCanvas}
                        >
                            Clear
                        </Button>
                        <Button
                            className={classnames('next-step-button', styles.buttons)}
                            variant="contained"
                            color="primary"
                            onClick={this.handleSubmit}
                            disabled={isSubmitting}
                        >
                            Agree and Submit
                        </Button>
                    </div>
                </div>
                <button
                    className={styles.close}
                    onClick={this.props.container.handleClose}
                ></button>
            </Dialog>
        );
    }
}
